import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  createCalendarExportLink(
    request: Boundaries["createCalendarExportLink"]["request"],
  ): void;
}

function useCreateCalendarExportLink(): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(
      selector.isCreateCalendarExportLinkRequestPending,
    ),
    isRequestSuccess: useSelector(
      selector.isCreateCalendarExportLinkRequestSuccess,
    ),
    isRequestFailure: useSelector(
      selector.isCreateCalendarExportLinkRequestFailure,
    ),
    createCalendarExportLink: core.createCalendarExportLink,
  };
}

export { useCreateCalendarExportLink };
